import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'item']

  connect () {
    this.refresh()
  }

  refresh () {
    const form = this.element.closest('form') || this.element
    let visible = 0
    this.itemTargets.forEach((item) => {
      const missing = this.#missing(form, item)
      item.hidden = !missing
      if (missing) visible += 1
    })
    if (this.hasListTarget) this.listTarget.hidden = visible === 0
  }

  #missing (form, item) {
    if (!this.#gateOpen(form, item)) return false

    const field = form.elements.namedItem(item.dataset.field)
    if (!field) return false

    return this.#value(field) === ''
  }

  #gateOpen (form, item) {
    const gateName = item.dataset.whenField
    if (!gateName) return true

    const gate = form.elements.namedItem(gateName)
    if (!gate) return false

    return this.#value(gate) === item.dataset.whenValue
  }

  #value (field) {
    if (typeof field.value !== 'string') return ''

    return field.value.trim()
  }
}
